import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native-web';

import { Button } from '../../../base-components';
import { ProgramGenders } from '../../../../shared/gender-enum';
import { useSelectedParams } from '../../../../hooks';
import { upperFirst } from '../../../../shared/string-manipulations';
import styles from '../styles';

const programGenders = Object.keys(ProgramGenders);

const propTypes = {
  onPress: PropTypes.func.isRequired,
  selectedGenders: PropTypes.arrayOf(PropTypes.string),
};
const defaultProps = {
  selectedGenders: undefined,
};

const GenderFilter = ({ onPress, selectedGenders }) => {
  const [selected, setSelected] = useSelectedParams(selectedGenders, onPress);

  const currentlySelected = selectedGenders || selected;

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        {programGenders.map(gender => (
          <Button
            key={gender}
            value={gender}
            label={upperFirst(gender)}
            variant="outline"
            style={styles.button}
            pressed={currentlySelected.includes(gender)}
            onPress={() => setSelected(gender)}
          />
        ))}
      </View>
    </View>
  );
};

GenderFilter.propTypes = propTypes;
GenderFilter.defaultProps = defaultProps;

export default GenderFilter;
